import React, { useState } from "react";
import { ChevronDown, ChevronUp, Check, X } from "lucide-react";
import '../../css/WhyFrothTestops.css';

import frothImg from "../../../assets/why-testops/froth.svg";
import jiraImg from "../../../assets/why-testops/jira.svg";
import testrailImg from "../../../assets/why-testops/testrail.svg";


export default function WhyFrothTestops() {
  const maintitle = [
    { id: "feature-a", title: "End-2-End Validation" },
    { id: "feature-b", title: "Test Suite Management" },
    { id: "feature-c", title: "Bug Lifecycle Management" },
    { id: "feature-g", title: "Automation" },
    { id: "feature-d", title: "Connectivity & Integrations" },
    { id: "feature-e", title: "Support" },
    { id: "feature-f", title: "Pricing" },
  ];

  const featureData = [
    [
      { label: "Requirement Lifecycle Management ", values: [true, true, false] },
      { label: "Test Case Lifecycle Management ", values: [true, false, true] },
      { label: "Defect Lifecycle Management ", values: [true, true, false] },
    ],
    [
      { label: "Centralized Test Management Across Projects ", values: [true, false, true] },
      { label: "Granular Test Step Tracking with Accurate Result Tracking ", values: [true, false, true] },
      { label: "End-to-End Test Traceability", values: [true, false, false] },
      { label: "Issue Mapping from Test Execution", values: [true, false, false] },
      { label: "Cross-Project Test Cloning ", values: [true, false, true] },
      { label: "Sign Off Feature for Release", values: [true, false, false] },
    ],
    [
      { label: "Smart Duplicate Issue Creation and Identification ", values: [true, true, false] },
      { label: "Unified View of Tests, Bugs & Requirements ", values: [true, false, false] },
      { label: "Multi-Issue Editing", values: [true, true, false] },
    ],
    [
      { label: "Web Application Testing  ", values: [true, true, true] },
      { label: "Mobile Application Testing (Android and iOS support) ", values: [true, false, false] },
      { label: "REST API Testing ", values: [true, false, false] },
      { label: "Schedule Test Execution ", values: [true, false, false] },
      { label: "Workflow-Based Test Execution ", values: [true, false, false] },
      { label: "Single Application for Entire STLC", values: [true, false, false] },
    ],
    [
      { label: "Seamless Integration with Third-Party Tools", values: [true, true, true] },
      { label: "Integration with Automated Testing Solutions ", values: [true, true, true] },
      { label: "Developer-Friendly API for Custom Integrations ", values: [true, true, true] },
    ],
    [
      { label: "Live Assistance Available", values: [true, false, false] },
      { label: "Fast Response Time", values: [true, true, false] },
      { label: "Self-Paced Learning Modules", values: [true, true, false] },
      { label: "User Guides and Tutorials", values: [true, true, true] },
      { label: "Scalable Support for Decentralized Teams", values: [true, true, true] },
    ],
    [
      { label: "In-house Infrastructure Solution", values: [true, true, true] },
      { label: "Cloud Infrastructure Solution", values: [true, true, true] },
      { label: "Customizable License Plans", values: [true, false, false] },
      { label: "Pricing Per Account", values: [true, false, false] },
    ],
  ];

  const valueImages = [
  frothImg,
  jiraImg,
  testrailImg,
];

  const [openId, setOpenId] = useState(null);

  const toggleAccordion = (id) => {
    setOpenId((prevId) => (prevId === id ? null : id));
  };

  const renderTableHeader = () => (
    <thead>
      <tr>
        <th>Features</th>
        {valueImages.map((src, i) => (
          <th key={i}>
            <img src={src} alt={`Value ${i + 1}`} className="logo-img" />
          </th>
        ))}
      </tr>
    </thead>
  );

  return (
    <section className="why-section">

      <h2 className="main-titles">
        Why Choose <span>Froth TestOps</span> for your Testing Team?
      </h2>

      <p className="descs">
        Looking for a simplified solution that integrates defect tracking and test case management without the need for multiple tools or expensive plugins?
      </p>

      <p className="descs">
        With our union Defect and Test Management Tool, you are able to plan your test strategy, manage execution cycles, and track defects through to resolution—all from one understandable platform. It is a goodbye to the constant need of exchanging information between systems and the battling with the old interfaces that no one understands.
      </p>

      <p className="descs">
        Senior test managers are enabled through the tool to develop comprehensive test plans, allocate resources, set test cycles, and even calculate efforts thus enhancing test readiness and lessening the delay caused by poor planning.
      </p>

      <p className="descs">
        Find out more about how our tool offers you greater flexibility, traceability, and control as compared to conventional test management suites and old bug trackers.
      </p>

      <div className="grid-container">

        {/* LEFT SIDE */}
        <div className="column">
          {[0, 1, 2, 3].map((index) => {
            const { id, title } = maintitle[index];
            const isOpen = openId === id;

            return (
              <div key={id} className="cards">
                <button className="accordion-btn" onClick={() => toggleAccordion(id)}>
                  {title}
                  {isOpen ? <ChevronUp /> : <ChevronDown />}
                </button>

                {isOpen && (
                  <div className="content">
                    <table>
                      {renderTableHeader()}
                      <tbody>
                        {featureData[index].map((row, i) => (
                          <tr key={i}>
                            <td>{row.label}</td>
                            {row.values.map((val, j) => (
                              <td key={j} className="icon-cell">
                                {val ? <Check className="check" /> : <X className="cross" />}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* RIGHT SIDE */}
        <div className="column">
          {[4, 5, 6].map((index) => {
            const { id, title } = maintitle[index];
            const isOpen = openId === id;

            return (
              <div key={id} className="cards">
                <button className="accordion-btn" onClick={() => toggleAccordion(id)}>
                  {title}
                  {isOpen ? <ChevronUp /> : <ChevronDown />}
                </button>

                {isOpen && (
                  <div className="content">
                    <table>
                      {renderTableHeader()}
                      <tbody>
                        {featureData[index].map((row, i) => (
                          <tr key={i}>
                            <td>{row.label}</td>
                            {row.values.map((val, j) => (
                              <td key={j} className="icon-cell">
                                {val ? <Check className="check" /> : <X className="cross" />}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>

    </section>
  );
}